import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap5";

export default class extends Controller {
  static values = {
    currentDisplayClass: String,
    setDisplayStyleUrl: String,
    modalTitle: String,
  };

  connect() {
    // $('#airplay_overlay_preview div.copy.'+ this.currentDisplayClassValue ).show();
    // $('#airplay_overlay_preview img.' + this.currentDisplayClassValue).removeClass('d-none');
    $(".modal").on("show.bs.modal", (event) => {
      // Button that triggered the modal

      const button = event.relatedTarget;
      if (button) {
        // Extract info from data-bs-* attributes
        const title = button.getAttribute("data-modal-title");
        // If necessary, you could initiate an Ajax request here
        // and then do the updating in a callback.
        console.log("title", title);
        // Update the modal's content.
        if (title) {
          const modalTitle = $(event.target).find(".modal-title").html(title);
        }
      }
    });

    // this.show_placeholder(this.currentDisplayClassValue);
  }

  modalTitleValueChanged() {
    $(".airplay_overlay_modals .modal-title").html(this.modalTitleValue);
  }

  preview(event) {
    var class_name = event.params.overlayClass || "default";

    $("#promo_selector_container button").removeClass("active");
    $(event.target).addClass("active");

    this.show_placeholder(class_name);
    // console.log("preview", class_name)
    // $('#airplay_overlay_preview .examples img').addClass('d-none').removeClass('d-block');
    // $(`#airplay_overlay_preview img.${class_name}`).removeClass('d-none').addClass('d-block');
    // $('#airplay_overlay_preview div.copy').addClass('d-none').removeClass('d-block');
    // $(`#airplay_overlay_preview div.copy.${class_name}`).removeClass('d-none').addClass('d-block');

    // $('#current_copy').addClass('d-none').removeClass('d-block');
    // $(`#current_copy.${class_name}`).removeClass('d-none').addClass('d-block');

    // if(class_name==current_display_style){
    //   $('#current_copy').show();
    //   $('#unit_switcher').hide();
    // }else{
    //   $('#current_copy').hide();
    //   $('#unit_switcher').show();
    // }
    // $('#current_overlay_button').html(current_display_name);
  }

  setOverlayStyle(event) {
    var style_code = event.params.displayStyle;
    console.log("set overlay style", style_code);
    $.post(
      this.setDisplayStyleUrlValue,
      { display_style: style_code },
      (data) => {
        if (data.error) {
          console.log("error", data.error);
          // var modalId = $(`div.modal[id*=${data.error}]`).attr("id");
          // //   .attr("id");
          // //  console.log("modalId", modalId);
          // // var modalId =  $(".modal").filter(":visible").attr("id");
          // if (data.error == "video_promo") {
          //   modalId = "video_feature_new_modal";
          // }
          this.modalTitleValue = data.message;
          //        Modal.getOrCreateInstance(`#${modalId}`).show()
          $("turbo-frame#modal").attr("src", data.modal_path);

          // Modal.getOrCreateInstance(`#${modalId}`).show();
        }
      }
    );
  }

  show_placeholder(class_name) {
    console.log("preview", class_name);
    $("#airplay_overlay_preview .examples img")
      .addClass("d-none")
      .removeClass("d-block");
    $(`#airplay_overlay_preview img.${class_name}`)
      .removeClass("d-none")
      .addClass("d-block");
    $("#airplay_overlay_preview div.copy")
      .addClass("d-none")
      .removeClass("d-block");
    $(`#airplay_overlay_preview div.copy.${class_name}`)
      .removeClass("d-none")
      .addClass("d-block");

    $("#current_copy").addClass("d-none").removeClass("d-block");
    $(`#current_copy.${class_name}`).removeClass("d-none").addClass("d-block");
  }
}
